import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const actions = {
  async getAddresses()
  {
    let url = apiUrl + 'Address/GetAll';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getAddress(c,id)
  {
    let url = apiUrl + 'Address/Get/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async addressDelete(c,id)
  {
    let url = apiUrl + 'Address/delete/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async setDefaultAddress(c, id)
  {
    let url = apiUrl + 'Address/setDefault/' + id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },


};

export default {
  namespaced: true,
  actions
}